/**
 * Created by nicom on 7/29/2017.
 */

export const Input = {
  NoChange: "NoChange",
  Change: "Change",
  InvalidFormat: "InvalidFormat",
  InvalidOrdering: "InvalidOrdering",
  InvalidOverlap: "InvalidOverlap",
  InvalidEmpty: "InvalidEmpty",
};

export const isInvalid = (val) =>
  val === Input.InvalidFormat ||
  val === Input.InvalidOrdering ||
  val === Input.InvalidOverlap ||
  val === Input.InvalidEmpty;
